export default {
    props: {
        uuID: {
            type: String,
            required: true
        },
        parentID: {
            type: String,
            required: true
        },
        teachers: {
            type: Array,
            default: () => ([])
        },
        classrooms: {
            type: Array,
            default: () => ([])
        },
        dateRange: {
            type: Object,
            required: true,
        },
    },
    methods: {
        onClose() {
            this.$emit("on-close");
        },
    }
};
